module.exports = __webpack_public_path__ + "static/media/agenda-close.9f327857.svg";